var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcnStar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.5L2.875 13L3.96875 8.3125L0.34375 5.15625L5.125 4.75L7 0.34375L8.875 4.75L13.6562 5.15625L10.0312 8.3125L11.125 13L7 10.5Z",
    fill: "#007BFF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnStar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn-star.ff5e4421.svg";
export { ForwardRef as ReactComponent };